// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Fragment } from 'react';
import { PartyCredentialRequirement } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import PartyDisplay from '../../components/PartyDisplay';
import RequiredClaims from './RequiredClaims';

interface CredentialRequirementsProps {
  credentialRequirements: PartyCredentialRequirement[];
}

const RequiredCredentials: React.FC<CredentialRequirementsProps> = ({ credentialRequirements }) => {
  return (
    <>
      {credentialRequirements.map((r, rIndex) => (
        <Fragment key={r.issuer}>
          <PartyDisplay party={r.issuer} />
          (<RequiredClaims requiredClaims={r.requiredClaims} />)
          {rIndex < credentialRequirements.length - 1 && ' ∧ '}
        </Fragment>
      ))}
    </>
  );
};

export default RequiredCredentials;
